import { render, staticRenderFns } from "./minimizeDialog.vue?vue&type=template&id=2d55bf5e&scoped=true"
import script from "./minimizeDialog.vue?vue&type=script&lang=js"
export * from "./minimizeDialog.vue?vue&type=script&lang=js"
import style0 from "./minimizeDialog.vue?vue&type=style&index=0&id=2d55bf5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d55bf5e",
  null
  
)

export default component.exports